export default __webpack_public_path__ + "static/iconography-image-i-4501b0e61055fb1c748b268126d34529.png";